<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1230px;">

      <el-form-item label="庫存數量">
        <el-input v-model="form.Count" type="number" step="1" min="0"></el-input>
      </el-form-item>
    </el-form>

    <table class="table-product-in-stock-log">
      <thead>
        <tr>
          <th>紀錄</th>
          <th>時間</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="log in logs" :key="`product-instock-log-${log.ID}`">
          <td v-if="log.Type == '後台修改'">管理員{{getUser(log.SourceID).Profile.Name}}設定庫存數量為{{log.CountValue}}</td>
          <td v-else-if="log.Type == '商品售出'">訂單{{log.SourceID}}售出商品{{log.CountValue}}個</td>
          <td v-else>紀錄異常</td>
          <td width="150">{{log.CreatedAt | moment}}</td>
        </tr>
      </tbody>
    </table>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinFilters],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        Count: 0
      },
      mIsShow: false,
      isLoading: false,
      logs: []
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return `${this.oriObj ? this.oriObj.Tw.Name : ''} 庫存設定`
    }
  },
  methods: {
    getUser (id) {
      return this.$store.state.user.list.find(o => o.ID == id) || { Profile: {} }
    },
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      this.form.Count = parseInt(this.form.Count) || 0
      this.$services.product.updateInStock(this, this.oriObj.ID, this.form).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.$emit('submitted', {
        productID: this.oriObj.ID,
        stockCount: this.form.Count
      })
      this.form = { Count: 0 }
      this.close()
    },
    loadResult (res) {
      {
        let idx = this.$store.state.product.list.findIndex(
          o => o.ID === this.oriObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.product.list[idx], 'InStock', this.form.Count)
        } else {
          console.error(`unknown product for id ${this.oriObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    fetchLogs () {
      this.$services.product.getInStockLog(this, this.oriObj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.logs = res.data.result
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = { Count: this.oriObj.InStock }
          this.fetchLogs()
        } else {
          this.form = {
            Count: 0
          }
        }
      }
    }
  }
}
</script>

<style>
.table-product-in-stock-log {
  width: 100%;
}
/* .table-product-in-stock-log tr:not(:first-child) th,
.table-product-in-stock-log tr:not(:first-child) td {
  padding-top: 30px;
} */
.table-product-in-stock-log th {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.46;
  letter-spacing: 1.04px;
  text-align: left;
  color: rgb(112, 112, 112);
  border-bottom: 1px solid #ccc;
  padding: 4px 0;
}
.table-product-in-stock-log td {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.47;
  letter-spacing: 1.2px;
  text-align: left;
  color: rgb(64, 62, 61);
  border-bottom: 1px solid #ccc;
  padding: 4px 0;
}
</style>
